(ns frontend.frontend-main
  (:require
   [clojure.edn :as edn]
   [common.i18n]
   [common.util :as u]
   [opengb.i18n]
   [re-frame.core :as rf]
   [shadow.graft :as graft]
   [frontend.telemetry]
   [frontend.views.activity-feed]
   [frontend.views.daily-chart]
   [frontend.views.date-range-filter]
   [frontend.views.disclosure]
   [frontend.views.map]
   [frontend.views.public]
   [frontend.views.retrofit-potential]
   [frontend.views.roadmap]
   [frontend.views.savings-waterfall]
   [frontend.views.retrofit-quiz]))

(defn ^:export init-graft
  "Call to initialize shadow-graft once page has loaded."
  []
  (graft/init edn/read-string))

(rf/reg-event-fx :frontend.frontend-main/init-db
  (fn [_ [_ {:keys [dictionaries debug?]}]]
    {:db {:opengb.i18n/dictionaries dictionaries
          :opengb.i18n/debug?      debug?}}))

(defmethod graft/scion (u/->scion-id :frontend.frontend-main/init-re-frame)
  [{:keys [tenant-slug debug?]} _]
  (let [dictionaries (common.i18n/get-dictionaries tenant-slug)]
    (rf/clear-subscription-cache!)
    (opengb.i18n/initialize-re-frame)
    (rf/dispatch-sync [:opengb.i18n/load-user-locale])
    (rf/dispatch-sync [:frontend.frontend-main/init-db {:dictionaries dictionaries
                                                        :debug?      debug?}])
    (frontend.telemetry/init-tracer!)))
